
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agentic-commerce",
      function () {
        return require("private-next-pages/agentic-commerce.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agentic-commerce"])
      });
    }
  